import { createFileRoute } from '@tanstack/react-router'

import GuestOrdersPage from '@/views/orders/pages/guest.orders.page'

export const Route = createFileRoute('/_layout/guest/orders/')({
  component: GuestOrdersPage,
})
